import type { AddressInfo, MetaDataObj, TagData } from 'src/helper/shared-types';
import type { GroupedDataMetaItem } from 'src/redux/list-view/types';
import type { LeftSection, RightSection } from '../work-order/types';

export type StatusUserInfo = {
  user_id: string;
  name: string | null;
  profile_pic: string | null;
  submitted_at: string | null;
  approved_at: string | null;
  rejected_at: string | null;
};

export type StatusType = 'approve' | 'reject' | 'pending-approval';

export type QuoteDataObj = {
  quote_id: string;
  quote_number: string;
  work_order_id: string;
  work_order_number: string;
  work_order_task_id: string;
  trip_id: string;
  assignees: Array<{
    name: string;
    user_id: string;
    profile_pic: string;
  }>;
  status: {
    label: string;
    value: string;
  };
  quote_submitted_details: StatusUserInfo;
  quote_approved_details: StatusUserInfo;
  quote_rejected_details: StatusUserInfo;
  category: [
    {
      label: string;
    },
  ];
  property: {
    address: AddressInfo;
  };
  timezone: string;
  tags: Array<string>;
  created_at: string;
  group: string;
  approved_total: number;
  total: number;
  market?: {
    id: string;
    name: string;
  };
  // Only Lula Pro Network rows carry these — MergedListResource emits them for
  // LulaQuote rows and omits them for native quotes. Lula quotes have no in-app
  // review pane; they are reviewed on Lula's hosted page at `public_url`.
  is_lula_quote?: boolean;
  public_url?: string;
};

export interface QuoteAPIResponseObj extends Omit<QuoteDataObj, 'tags'> {
  tags: Array<TagData>;
}

export type InitialQuoteStateType = {
  isLoading: boolean;
  data: {
    data: string[];
    meta: MetaDataObj;
  };
  groupedData: {
    [key: string]: Array<string>;
  };
  groupedDataMeta: {
    [key: string]: GroupedDataMetaItem;
  };
  source: { [key: string]: QuoteDataObj };
  tagSource: {
    [key: string]: TagData;
  };
  showSidePanel: {
    needToRefetch?: boolean;
    isOpen?: boolean;
    quoteId?: string;
    leftSection?: LeftSection | null;
    rightSection?: RightSection | null;
    mobileSection?: RightSection | null;
  } | null;
  currentFilterReferenceObj: { [key: string]: any };
  isFetchingQuotes: boolean;
};

export type QuoteFilterStatus = {
  label: string;
  value: string;
};

export const quoteInitialState: InitialQuoteStateType = {
  isLoading: false,
  data: {
    data: [],
    meta: {
      current_page: 0,
      from: 0,
      last: '',
      next: '',
      per_page: 0,
      prev: '',
      to: 0,
      total: 0,
    },
  },
  groupedData: {},
  groupedDataMeta: {},
  tagSource: {},
  source: {},
  showSidePanel: null,
  currentFilterReferenceObj: {},
  isFetchingQuotes: true,
};
